export default __webpack_public_path__ + "static/media/AridhiaDRE-PoweredBy.660bc012.svg";